import { Text } from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';

interface DnbLegalTextProps {
  className?: string;
}

export const DnbLegalText = ({ className }: DnbLegalTextProps) => {
  const { t } = useTranslation();

  return (
    <Text.H14 className={className || 'text-text-main-secondary'}>
      <span className='block'>{t('pages.dnbEmbeddedIntro.legal.apy')}</span>
      <span className='block'>{t('pages.dnbEmbeddedIntro.legal.businessBuild')}</span>
      <span className='block'>{t('pages.dnbEmbeddedIntro.legal.welcomeBonus')}</span>
      <span className='block'>
        <Trans
          i18nKey='pages.dnbEmbeddedIntro.legal.fdic'
          components={{
            sunriseLink: (
              <a
                className='underline'
                href='https://lili.co/legal-documents/sunrise-account-agreement'
                target='_blank'
                rel='noopener noreferrer'
              />
            ),
            addendumLink: (
              <a
                className='underline'
                href='https://lili.co/legal-documents/addendum-to-sunrise-banks-account-agreement'
                target='_blank'
                rel='noopener noreferrer'
              />
            ),
          }}
        />
      </span>
      <span className='block'>{t('pages.dnbEmbeddedIntro.legal.loans')}</span>
    </Text.H14>
  );
};

export default DnbLegalText;
